import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../storageService/offlineService";
import { OfflineSyncService } from "../storageService/offlineSyncService";

const LoadHuddles = (defaultSite, date) => {
    const offlineService = new OfflineService();

    HttpService.post('/Huddle/GetHuddles', {
        SiteId: defaultSite.id,
        CreatedDateTime: date
    })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }

            offlineService.removeOfflineBySite(defaultSite.id, "HuddleDetails");
            offlineService.addOffline(defaultSite.id, "HuddleDetails", result);
        },
            (error) => {
                console.log(error);
            });
};

const GetHuddles = async (siteId) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "HuddleDetails");
    return offlineResult.OfflineData;
};

const SaveHuddleOfflineData = async (siteId, entityId, keyName, item, url, isOnline, remove) => {
    const offlineSyncService = new OfflineSyncService();

    if (!isOnline) {
        let exists = await offlineSyncService.getByNameAndEntityId(entityId, keyName);
        if (exists) {
            offlineSyncService.updateById(exists.Id, item);
        }
        else {
            offlineSyncService.add(siteId, entityId, url, keyName, item);
        }
    }

    UpdateOfflineData(siteId, item, remove);
};

const UpdateOfflineData = async (siteId, item, remove) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "HuddleDetails");
    const data = offlineResult.OfflineData;
    const index = data.findIndex(d => d.Name === item.Name);

    if (remove) {
        offlineResult.OfflineData.splice(index, 1);
    }
    else if (index === -1)
        offlineResult.OfflineData.push(item);
    else {
        offlineResult.OfflineData[index] = item;
    }

    offlineService.updateOfflineByName(siteId, "HuddleDetails", offlineResult.OfflineData);
};

export { LoadHuddles, GetHuddles, SaveHuddleOfflineData };
